import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class ExitIcon extends Component {
    render () {
        let finalClassName = Icon.buildCssClass(this.props);

        return (
            <svg className={finalClassName} width="32" height="32" viewBox="0 0 30 30">
                <path d="M16.2583 24.4849C16.2583 24.9536 15.9118 25.3334 15.484 25.3334H8.77459C8.34685 25.3334 8.00024 24.9536 8.00024 24.4849V7.51527C8.00024 7.0466 8.34685 6.66669 8.77459 6.66669H15.484C15.9118 6.66669 16.2583 7.0466 16.2583 7.51527C16.2583 7.98381 15.9118 8.3637 15.484 8.3637H9.54862V23.6363H15.484C15.9118 23.6363 16.2583 24.0162 16.2583 24.4849ZM19.0658 11.4402C19.3681 11.1089 19.8584 11.1089 20.1605 11.4402L23.7734 15.4001C24.0758 15.7314 24.0758 16.2688 23.7734 16.5999L20.1605 20.5597C20.0095 20.7253 19.8114 20.8082 19.6131 20.8082C19.415 20.8082 19.2168 20.7253 19.0658 20.5597C18.7634 20.2284 18.7634 19.691 19.0658 19.3595L21.3568 16.8486H11.8713C11.4438 16.8486 11.0973 16.4687 11.0973 16C11.0973 15.5315 11.4438 15.1516 11.8713 15.1516H21.3571L19.0658 12.6403C18.7634 12.3087 18.7634 11.7717 19.0658 11.4402Z" />
            </svg>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Exit.js